<template>
    <div id="page-products" class="page-products">
        <div class="page-title-box">
            <div class="page-title-right">
                <nav aria-label="breadcrumb">
                    <ol class="breadcrumb mb-0">
                        <li class="breadcrumb-item">
                            <router-link :to="{ 'name': 'home'}" href="#">Home</router-link>
                        </li>
                        <li class="breadcrumb-item active" aria-current="page">Products</li>
                    </ol>
                </nav>
            </div>
            <div class="page-title-left">
                <h2 class="page-title">Products</h2>
            </div>
        </div>
        <div class="card">
            <div class="card-body">
                <div class="table-responsive">
                    <div class="dataTables_wrapper dt-bootstrap4 no-footer">
                        <div class="top-nav-container row">
                            <top-pagination
                                :metadata="pagination"
                                :results="products"
                                v-on:change="load"
                                v-on:reset="reset"
                                :searchText="search"
                            ></top-pagination>
                        </div>
                        <table
                            class="table table-centered w-100 dt-responsive nowrap"
                            id="products-datatable"
                        >
                            <thead class="thead-light">
                                <tr>
                                    <th class="image-col">&nbsp;</th>
                                    <result-table-header
                                        :order.sync="order"
                                        :direction.sync="direction"
                                        order-key="name"
                                        class="all"
                                    >Product Name</result-table-header>
                                    <th>State</th>
                                    <th style="width: 85px;">Action</th>
                                </tr>
                            </thead>
                            <template v-if="!loading">
                                <tbody v-if="!empty">
                                    <tr v-for="product in products" :key="product.id">
                                        <td class="image-col">
                                            <div
                                                class="image-container"
                                                :style="getThumbnailUrl(product)"
                                            ></div>
                                        </td>
                                        <td>
                                            <a
                                                href="#"
                                                class="text-body file-name"
                                                @click.prevent="showDetail(product.id)"
                                            >{{ product.name }}</a>
                                        </td>
                                        <td>
                                            <span
                                                class="product-state-label"
                                                :class="[getStateClass(product)]"
                                                v-text="getStateLabel(product)"
                                            ></span>
                                        </td>

                                        <td class="table-action">
                                            <a
                                                href="#"
                                                @click.prevent="showDetail(product.id)"
                                                class="action-icon"
                                            >
                                                <i class="mdi mdi-pencil"></i>
                                            </a>
                                        </td>
                                    </tr>
                                </tbody>
                                <tbody class="empty" v-else>
                                    <tr>
                                        <td colspan="3">
                                            <div class="d-flex justify-content-center">List is empty</div>
                                        </td>
                                    </tr>
                                </tbody>
                            </template>
                            <tbody class="loading" v-else>
                                <tr>
                                    <td colspan="3">
                                        <div class="d-flex justify-content-center">
                                            <div class="spinner-border" role="status"></div>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                        <pagination
                            :metadata="pagination"
                            :results="products"
                            v-on:change="load"
                            v-on:reset="reset"
                        ></pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
import moment from "moment";

import product from "@/client/api/product";

import TopPagination from "@/ui/TopPagination";
import Pagination from "@/ui/Pagination";
import ResultTableHeader from "@/ui/ResultTableHeader";

export default {
    components: {
        TopPagination,
        Pagination,
        ResultTableHeader
    },
    data() {
        return {
            products: [],
            pagination: {},
            order: null,
            direction: null,
            empty: false,
            loading: false,
            per_page: null,
            search: null
        };
    },
    watch: {
        $route: {
            handler: "loadFirstPage",
            immediate: true
        },
        order: function(val, oldVal) {
            if (val && oldVal != null) {
                this.changeOrder();
            }
        },
        direction: function(val, oldVal) {
            if (val && oldVal != null) {
                this.changeOrder();
            }
        }
    },
    methods: {
        loadFirstPage() {
            this.load(1);
        },
        async load(page = null) {
            this.loading = true;
            let params = {
                search: this.search,
                order: this.order,
                direction: this.direction
            };

            let res = await product.getProducts(
                this.currentWebsiteId,
                page,
                this.per_page,
                params
            );

            if (res.data) {
                if (res.data.data) {
                    this.products = res.data.data;
                    this.empty = !this.products.length;
                }

                if (res.data.meta) {
                    this.pagination = res.data.meta;
                }

                if (res.data.meta && res.data.meta.order) {
                    this.order = res.data.meta.order;
                } else {
                    this.order = null;
                }
                if (res.data.meta && res.data.meta.direction) {
                    this.direction = res.data.meta.direction;
                } else {
                    this.direction = null;
                }
            }

            this.loading = false;
        },
        reset(params) {
            this.per_page = params[0];
            this.search = params[1];
            this.load(1);
        },
        getCreatedDate(product) {
            return moment(product).format("lll");
        },
        getStateLabel(product) {
            if (product.state == 1) {
                return "Active";
            } else if (product.state == 0) {
                return "Inactive";
            }
        },
        getStateClass(product) {
            if (product.state == 1) {
                return "active";
            } else if (product.state == 0) {
                return "";
            }
        },
        getThumbnailUrl(product) {
            if (product.image_url) {
                return { backgroundImage: "url(" + product.image_url + ")" };
            }
        },
        showDetail(product_id) {
            this.$router.push({
                name: "website-products-detail",
                params: { site_id: this.currentWebsiteId, product_id }
            });
        }
    },
    computed: {
        ...mapState(["currentWebsiteId"])
    }
};
</script>

<style lang="scss">
.top-nav-container {
    .pagination-container {
        flex: 1;
        margin: 0;

        & > :last-child {
            padding-right: 0;
        }
    }
}

#products-datatable {
    th {
        .direction {
            margin-left: 5px;
        }
    }

    .image-col {
        width: rem-calc(64);

        .image-container {
            width: rem-calc(64);
            height: rem-calc(64);
            border-radius: rem-calc(5);
            background-position: center center;
            background-repeat: no-repeat;
            background-size: cover;
            background-color: #efefef;
            background-image: url("../img/icon-product.png");
            overflow: hidden;

            @include retina {
                background-image: url("../img/icon-product@2x.png");
            }
        }
    }
}
</style>